export default __webpack_public_path__ + "static/media/012-food truck.2ba93625.svg";